import React, { Component } from 'react';

import {
  Switch, Route
} from "react-router-dom";

import { persistor, store } from './store';
import { PersistGate } from 'redux-persist/lib/integration/react';
import {Provider} from 'react-redux';

import './App.css';

import LoadingScreen from './containers/Main/LoadingScreen';
// import main screens 
import Login from './containers/Login';
import Main from './containers/Main';
import runOneSignal from './utils/oneSignal';

class App extends Component {

  componentWillMount() {
    runOneSignal()
	}

  render() {
    return (
        <Provider store={store}>
            <PersistGate loading={<LoadingScreen/>} persistor={persistor}>
              <Switch>
                <Route exact path='/login' component={Login}/>
                <Route path='/' component={Main} />
              </Switch>
            </PersistGate>
        </Provider>
    );
  }
}

export default App;
